// extracted by mini-css-extract-plugin
var _1 = "TabScrollButton-moduleTabScrollButton__aprNm";
var _2 = "TabScrollButton-modulebutton__c_huS";
export { _1 as "TabScrollButton", _2 as "button" }
